(function () {
  const GRADES = ['fair', 'good', 'very-good', 'excellent'];
  const DEVICES = ['smartphone', 'smartwatch', 'apple-watch', 'samsung-watch', 'pixel-watch', 'console', 'mixer', 'oven', 'laptop'];
  const SLIDE_KEYS = ['device', 'screen', 'body'];

  const GRADE_META = {
    fair: {
      summary: 'Visible cosmetic wear that does not affect performance.',
      wearChip: 'Visible signs of use',
      batteryChip: 'Battery for daily use',
      deviceArt: 'rebx-tradein-condition-fair.svg',
      screenArt: 'rebx-tradein-screen-visible.svg',
      bodyArt: 'rebx-tradein-body-heavy.svg',
    },
    good: {
      summary: 'Light cosmetic wear that is not noticeable from arm\'s length.',
      wearChip: 'Light signs of use',
      batteryChip: 'Battery for daily use',
      deviceArt: 'rebx-tradein-condition-good.svg',
      screenArt: 'rebx-tradein-screen-flawless.svg',
      bodyArt: 'rebx-tradein-body-light.svg',
    },
    'very-good': {
      summary: 'Minimal wear that is hard to spot unless you look closely.',
      wearChip: 'Minimal signs of use',
      batteryChip: 'Battery for daily use',
      deviceArt: 'rebx-tradein-condition-very-good.svg',
      screenArt: 'rebx-tradein-screen-minor.svg',
      bodyArt: 'rebx-tradein-body-light.svg',
    },
    excellent: {
      summary: 'Like new. Minimal to no signs of use.',
      wearChip: 'Minimal to no signs of use',
      batteryChip: '12-month warranty',
      deviceArt: 'rebx-tradein-condition-excellent.svg',
      screenArt: 'rebx-tradein-screen-flawless.svg',
      bodyArt: 'rebx-tradein-body-flawless.svg',
    },
  };

  // Full multi-angle collages (falls back to GRADE_META art).
  const PHOTO_OVERRIDES = {
    'smartphone:fair': {
      device: 'rebx-grade-fair-phone-collage.jpg',
      singleCollage: true,
    },
    'smartphone:good': {
      device: 'rebx-grade-good-phone-collage.jpg',
      singleCollage: true,
    },
    'smartphone:very-good': {
      device: 'rebx-grade-very-good-phone-collage.jpg',
      singleCollage: true,
    },
    'smartphone:excellent': {
      device: 'rebx-grade-excellent-phone-collage.jpg',
      singleCollage: true,
    },
    'apple-watch:excellent': {
      device: 'rebx-grade-excellent-apple-watch-collage.jpg',
      singleCollage: true,
    },
    'apple-watch:very-good': {
      device: 'rebx-grade-very-good-apple-watch-collage.jpg',
      singleCollage: true,
    },
    'apple-watch:good': {
      device: 'rebx-grade-good-apple-watch-collage.jpg',
      singleCollage: true,
    },
    'samsung-watch:fair': {
      device: 'rebx-grade-fair-samsung-watch-collage.jpg',
      singleCollage: true,
    },
    'samsung-watch:good': {
      device: 'rebx-grade-good-samsung-watch-collage.jpg',
      singleCollage: true,
    },
    'samsung-watch:very-good': {
      device: 'rebx-grade-very-good-samsung-watch-collage.jpg',
      singleCollage: true,
    },
    'samsung-watch:excellent': {
      device: 'rebx-grade-excellent-samsung-watch-collage.jpg',
      singleCollage: true,
    },
    'pixel-watch:fair': {
      device: 'rebx-grade-fair-pixel-watch-collage.jpg',
      singleCollage: true,
    },
    'pixel-watch:good': {
      device: 'rebx-grade-good-pixel-watch-collage.jpg',
      singleCollage: true,
    },
    'pixel-watch:very-good': {
      device: 'rebx-grade-very-good-pixel-watch-collage.jpg',
      singleCollage: true,
    },
    'pixel-watch:excellent': {
      device: 'rebx-grade-excellent-pixel-watch-collage.jpg',
      singleCollage: true,
    },
    'console:fair': {
      device: 'rebx-grade-fair-console-collage.jpg',
      singleCollage: true,
    },
    'console:good': {
      device: 'rebx-grade-good-console-collage.jpg',
      singleCollage: true,
    },
    'console:very-good': {
      device: 'rebx-grade-very-good-console-collage.jpg',
      singleCollage: true,
    },
    'console:excellent': {
      device: 'rebx-grade-excellent-console-collage.jpg',
      singleCollage: true,
    },
    'mixer:fair': {
      device: 'rebx-grade-fair-mixer-collage.jpg',
      singleCollage: true,
    },
    'mixer:good': {
      device: 'rebx-grade-good-mixer-collage.jpg',
      singleCollage: true,
    },
    'mixer:very-good': {
      device: 'rebx-grade-very-good-mixer-collage.jpg',
      singleCollage: true,
    },
    'mixer:excellent': {
      device: 'rebx-grade-excellent-mixer-collage.jpg',
      singleCollage: true,
    },
    'oven:fair': {
      device: 'rebx-grade-fair-oven-collage.jpg',
      singleCollage: true,
    },
    'oven:good': {
      device: 'rebx-grade-good-oven-collage.jpg',
      singleCollage: true,
    },
    'oven:very-good': {
      device: 'rebx-grade-very-good-oven-collage.jpg',
      singleCollage: true,
    },
    'oven:excellent': {
      device: 'rebx-grade-excellent-oven-collage.jpg',
      singleCollage: true,
    },
    'laptop:fair': {
      device: 'rebx-grade-fair-laptop-collage.jpg',
      singleCollage: true,
    },
    'laptop:good': {
      device: 'rebx-grade-good-laptop-collage.jpg',
      singleCollage: true,
    },
    'laptop:very-good': {
      device: 'rebx-grade-very-good-laptop-collage.jpg',
      singleCollage: true,
    },
    'laptop:excellent': {
      device: 'rebx-grade-excellent-laptop-collage.jpg',
      singleCollage: true,
    },
  };

  const DEVICE_GRADES = {
    smartphone: {
      fair: {
        screen: 'May have light scratches that are slightly visible when the device is on.',
        body: 'Signs of wear including visible scratches and dents on the body that do not affect performance.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Minimum 80% battery health. Suitable for everyday use.',
      },
      good: {
        screen: 'No scratches on the screen. Light micro-scratches on the body are not visible from arm\'s length.',
        body: 'Light signs of wear. Micro-scratches on the body are not visible from about 20 inches away.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Good battery health: minimum 80% capacity with reliable daily performance.',
      },
      'very-good': {
        screen: 'No scratches on the screen. Minimal to no visible marks when the device is on.',
        body: 'Almost no signs of wear. Very light micro-scratches, if any, are hard to spot up close.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Strong battery health: minimum 80% capacity with reliable daily performance.',
      },
      excellent: {
        screen: 'No scratches on the screen. Minimal to no visible marks when the device is on.',
        body: 'Almost no signs of wear. Very light micro-scratches, if any, are not visible from 8 inches away.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Strong battery performance with minimum 80% capacity for everyday use.',
      },
    },
    smartwatch: {
      fair: {
        screen: 'Display may show light scratches visible when the watch face is on.',
        body: 'Case and strap show visible wear, scuffs or scratches that do not affect performance.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Minimum 80% battery health. Suitable for everyday use.',
      },
      good: {
        screen: 'No scratches on the display. Light micro-scratches on the case are hard to see at arm\'s length.',
        body: 'Light signs of wear on the case or strap, not noticeable from about 20 inches away.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Good battery health: minimum 80% capacity with reliable daily performance.',
      },
      'very-good': {
        summary: 'Light signs of use. Looks great from normal viewing distance.',
        screen: 'May show light hairline scratches when the display is off or under bright light.',
        body: 'Minor scuffs or marks on the case that are hard to notice at arm\'s length.',
        hardware: '100% functional. Fully tested.',
        battery: '12-month warranty included.',
        overall: 'Fully tested and works like new.',
      },
      excellent: {
        summary: 'Like new. Minimal to no signs of use.',
        screen: 'Excellent condition, no visible scratches.',
        body: 'No visible scratches or marks. Buttons are fully functional with no signs of wear.',
        hardware: '100% functional. Fully tested.',
        battery: '12-month warranty included.',
        overall: 'Looks and works like new.',
      },
    },
    console: {
      fair: {
        screen: 'May show light scuffs or marks on the shell, panels or controller grips.',
        body: 'Visible wear on the casing or ports that does not affect performance.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'All essential functions tested. Power, inputs and storage verified where applicable.',
      },
      good: {
        screen: 'Light cosmetic marks only. Easy to overlook from normal viewing distance.',
        body: 'Minor signs of use on the shell or grips, not noticeable from arm\'s length.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Fully tested for reliable everyday use with our quality checks.',
      },
      'very-good': {
        screen: 'Minimal to no visible marks on shell, panels or controller surfaces.',
        body: 'Almost no signs of wear. Any marks are hard to spot up close.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Fully tested with strong performance across all key functions.',
      },
      excellent: {
        screen: 'Minimal to no visible cosmetic marks on the shell or controller.',
        body: 'Very light marks, if any, are not visible from normal viewing distance.',
        hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
        battery: 'Fully tested and ready for everyday use.',
      },
    },
  };

  const SLIDE_LABELS = {
    smartphone: ['Body', 'Screen', 'Body'],
    smartwatch: ['Overview', 'Screen', 'Body'],
    console: ['Shell & panels', 'Shell & panels', 'Ports & vents'],
  };

  const DETAIL_LABELS = {
    smartphone: { device: 'Overview', screen: 'Screen', body: 'Body' },
    smartwatch: { device: 'Overview', screen: 'Screen', body: 'Body' },
    console: { device: 'Overview', screen: 'Shell & panels', body: 'Ports & vents' },
    mixer: { device: 'Overview', screen: 'Finish', body: 'Parts' },
    oven: { device: 'Overview', screen: 'Finish', body: 'Basket & plates' },
  };

  DEVICE_GRADES.mixer = {
    fair: {
      summary: 'Visible cosmetic wear that does not affect performance.',
      screen: 'Visible scratches and scuffs on the body, jug or lid.',
      body: 'Marks on metal, plastic and blades that do not affect use.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    good: {
      summary: 'Light cosmetic wear that is not noticeable from arm\'s length.',
      screen: 'Light marks on the body or jug that are easy to overlook.',
      body: 'Light signs of use on metal and plastic that do not affect performance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    'very-good': {
      summary: 'Minimal wear that is hard to spot unless you look closely.',
      screen: 'Minimal marks on the body, jug or lid.',
      body: 'Almost no signs of wear. Any marks are hard to spot up close.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    excellent: {
      summary: 'Like new. Minimal to no signs of use.',
      screen: 'Minimal to no visible marks on the body, jug or lid.',
      body: 'Very light marks, if any, are not visible from normal viewing distance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
  };

  SLIDE_LABELS.mixer = ['Overview', 'Finish', 'Parts'];

  DEVICE_GRADES.oven = {
    fair: {
      summary: 'Visible cosmetic wear that does not affect performance.',
      screen: 'Visible scratches and scuffs on the body, door or basket.',
      body: 'Marks on metal, plastic, plates and the basket that do not affect use.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    good: {
      summary: 'Light cosmetic wear that is not noticeable from arm\'s length.',
      screen: 'Light marks on the body or basket that are easy to overlook.',
      body: 'Light signs of use on metal, plastic and plates that do not affect performance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    'very-good': {
      summary: 'Minimal wear that is hard to spot unless you look closely.',
      screen: 'Minimal marks on the body, door or basket.',
      body: 'Almost no signs of wear. Any marks are hard to spot up close.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    excellent: {
      summary: 'Like new. Minimal to no signs of use.',
      screen: 'Minimal to no visible marks on the body, door or basket.',
      body: 'Very light marks, if any, are not visible from normal viewing distance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
  };

  SLIDE_LABELS.oven = ['Overview', 'Finish', 'Basket & plates'];
  SLIDE_LABELS.laptop = ['Lid', 'Screen', 'Keyboard & ports'];

  DEVICE_GRADES.laptop = {
    fair: {
      summary: 'Visible cosmetic wear that does not affect performance.',
      screen: 'The screen may show scratches that are visible when it is off.',
      body: 'The lid, palm rest and ports show visible scratches and scuffs that do not affect use.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    good: {
      summary: 'Light cosmetic wear that is not noticeable from arm\'s length.',
      screen: 'Light marks on the screen that are easy to overlook.',
      body: 'Light signs of use on the lid and keyboard that do not affect performance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    'very-good': {
      summary: 'Minimal wear that is hard to spot unless you look closely.',
      screen: 'Minimal marks on the screen.',
      body: 'Almost no signs of wear on the lid, keyboard or ports.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
    excellent: {
      summary: 'Like new. Minimal to no signs of use.',
      screen: 'Minimal to no visible marks on the screen.',
      body: 'Very light marks, if any, are not visible from normal viewing distance.',
      hardware: '100% fully functional. Inspected, tested and cleaned by RebX certified technicians.',
    },
  };

  DETAIL_LABELS.laptop = { device: 'Overview', screen: 'Screen', body: 'Keyboard & ports' };

  DEVICE_GRADES['apple-watch'] = DEVICE_GRADES.smartwatch;
  DEVICE_GRADES['samsung-watch'] = DEVICE_GRADES.smartwatch;
  DEVICE_GRADES['pixel-watch'] = DEVICE_GRADES.smartwatch;
  SLIDE_LABELS['apple-watch'] = SLIDE_LABELS.smartwatch;
  SLIDE_LABELS['samsung-watch'] = SLIDE_LABELS.smartwatch;
  SLIDE_LABELS['pixel-watch'] = SLIDE_LABELS.smartwatch;
  DETAIL_LABELS['apple-watch'] = DETAIL_LABELS.smartwatch;
  DETAIL_LABELS['samsung-watch'] = DETAIL_LABELS.smartwatch;
  DETAIL_LABELS['pixel-watch'] = DETAIL_LABELS.smartwatch;

  const CHIP_ICONS = {
    wear: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 14c3-4 13-4 16 0"/><path d="M6 18c2-2 10-2 12 0"/></svg>',
    functional: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12l4 4L19 6"/></svg>',
    battery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 10v4"/><path d="M7 11v2M11 11v2M15 11v2"/></svg>',
  };

  function normalizeGrade(value) {
    return GRADES.includes(value) ? value : 'fair';
  }

  function normalizeDevice(value) {
    return DEVICES.includes(value) ? value : 'smartphone';
  }

  function assetUrl(root, filename) {
    const sample = root.dataset.assetSample || '';
    if (!sample) return filename;
    return sample.replace(/rebx-tradein-[^/?#]+(?:\?.*)?$/, filename);
  }

  function buildSlides(root, device, grade) {
    const meta = GRADE_META[grade];
    const photos = PHOTO_OVERRIDES[`${device}:${grade}`] || {};

    // One full collage that shows all angles at once
    if (photos.singleCollage && photos.device) {
      return [
        {
          key: 'device',
          label: 'All angles',
          src: assetUrl(root, photos.device),
          alt: `Example photos for ${grade.replace('-', ' ')} refurbished ${device}`,
          isPhoto: true,
          isCollage: true,
        },
      ];
    }

    const arts = [
      photos.device || meta.deviceArt,
      photos.screen || meta.screenArt,
      photos.body || meta.bodyArt,
    ];
    const labels = SLIDE_LABELS[device];

    return arts.map((file, index) => ({
      key: SLIDE_KEYS[index],
      label: labels[index],
      src: assetUrl(root, file),
      alt: `Example ${labels[index].toLowerCase()} for ${grade.replace('-', ' ')} refurbished ${device}`,
      isPhoto: /\.(jpe?g|png|webp)$/i.test(file),
    }));
  }

  function initGuide(root) {
    const productMode = root.dataset.productMode === 'true';
    const staticOverview = root.dataset.staticOverview === 'true';
    const initialGrade = normalizeGrade(root.dataset.initialGrade);
    const initialDevice = normalizeDevice(root.dataset.initialDevice);

    let activeGrade = initialGrade;
    let activeDevice = initialDevice;
    let activeSlide = 0;
    let slides = buildSlides(root, activeDevice, activeGrade);

    const carousel = root.querySelector('[data-guide-carousel]');
    const dotsWrap = root.querySelector('[data-guide-dots]');
    const slideLabelNode = root.querySelector('[data-guide-slide-label]');
    const slideTextNode = root.querySelector('[data-guide-slide-text]');
    const gradeSummaryNode = root.querySelector('[data-guide-grade-summary]');
    const deviceButtons = Array.from(root.querySelectorAll('[data-guide-device]'));
    const gradeButtons = productMode ? [] : Array.from(root.querySelectorAll('[data-guide-grade]'));
    const prevBtn = root.querySelector('[data-guide-prev]');
    const nextBtn = root.querySelector('[data-guide-next]');

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function renderCarousel() {
      if (!carousel || !dotsWrap) return;

      carousel.innerHTML = slides
        .map(
          (slide, index) => `
            <div class="rebx-grading-guide__slide${index === activeSlide ? ' is-active' : ''}${slide.isCollage ? ' rebx-grading-guide__slide--collage' : ''}" data-slide="${index}">
              <span class="rebx-grading-guide__example-tag">Example image</span>
              <span class="rebx-grading-guide__slide-label">${slide.label}</span>
              <img src="${slide.src}" alt="${slide.alt}" width="${slide.isCollage ? 390 : 400}" height="${slide.isCollage ? 390 : 280}" loading="lazy" decoding="async" class="${slide.isCollage ? 'rebx-grading-guide__photo rebx-grading-guide__photo--collage' : slide.isPhoto ? 'rebx-grading-guide__photo' : ''}">
            </div>`
        )
        .join('');

      if (slides.length <= 1) {
        dotsWrap.innerHTML = '';
      } else {
        dotsWrap.innerHTML = slides
          .map(
            (_, index) =>
              `<button type="button" class="rebx-grading-guide__dot${index === activeSlide ? ' is-active' : ''}" data-slide-dot="${index}" aria-label="Show example ${index + 1}"></button>`
          )
          .join('');

        dotsWrap.querySelectorAll('[data-slide-dot]').forEach((dot) => {
          dot.addEventListener('click', () => {
            activeSlide = Number(dot.dataset.slideDot);
            renderCarousel();
            renderSlideDetail();
          });
        });
      }

      const nav = root.querySelector('.rebx-grading-guide__nav');
      if (nav) nav.hidden = slides.length <= 1;
    }

    function gradeSummaryText() {
      const copy = DEVICE_GRADES[activeDevice][activeGrade] || {};
      return copy.summary || GRADE_META[activeGrade].summary;
    }

    function renderGradeSummary() {
      if (!gradeSummaryNode) return;
      gradeSummaryNode.textContent = gradeSummaryText();
    }

    function overviewHtml() {
      const copy = DEVICE_GRADES[activeDevice][activeGrade] || {};
      const parts = [];
      const summary = gradeSummaryText();
      if (summary) parts.push(`<p>${escapeHtml(summary)}</p>`);
      if (copy.overall) parts.push(`<p>${escapeHtml(copy.overall)}</p>`);
      if (copy.screen) parts.push(`<p><strong>Screen:</strong> ${escapeHtml(copy.screen)}</p>`);
      if (copy.body) parts.push(`<p><strong>Body:</strong> ${escapeHtml(copy.body)}</p>`);
      if (copy.hardware) parts.push(`<p><strong>Function:</strong> ${escapeHtml(copy.hardware)}</p>`);
      if (copy.battery) parts.push(`<p><strong>Battery:</strong> ${escapeHtml(copy.battery)}</p>`);
      return parts.join('');
    }

    function renderSlideDetail() {
      if (slideLabelNode) slideLabelNode.textContent = 'Overview';

      if (productMode) {
        if (staticOverview) return;
        if (slideTextNode) slideTextNode.innerHTML = overviewHtml();
        return;
      }

      const copy = DEVICE_GRADES[activeDevice][activeGrade];
      const labels = DETAIL_LABELS[activeDevice];
      const slide = slides[activeSlide];
      if (!slide) return;

      let label = slide.isCollage ? 'Condition examples' : labels[slide.key];
      let text = gradeSummaryText();

      if (slide.isCollage) {
        text = [
          gradeSummaryText(),
          copy.overall,
          copy.screen ? `${labels.screen}: ${copy.screen}` : '',
          copy.body ? `${labels.body}: ${copy.body}` : '',
        ]
          .filter(Boolean)
          .join(' ');
      } else if (slide.key === 'device' && copy.overall) {
        text = `${gradeSummaryText()} ${copy.overall}`;
      } else if (slide.key === 'screen') {
        text = copy.screen;
      } else if (slide.key === 'body') {
        text = copy.body;
      }

      if (slideLabelNode) slideLabelNode.textContent = label;
      if (slideTextNode) slideTextNode.textContent = text;
    }

    function renderGrades() {
      gradeButtons.forEach((button) => {
        const isActive = button.dataset.guideGrade === activeGrade;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function renderDevices() {
      deviceButtons.forEach((button) => {
        const isActive = button.dataset.guideDevice === activeDevice;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function renderAll() {
      slides = buildSlides(root, activeDevice, activeGrade);
      if (activeSlide >= slides.length) activeSlide = 0;
      if (!productMode) renderCarousel();
      renderGradeSummary();
      renderSlideDetail();
      renderGrades();
      renderDevices();
    }

    if (!productMode && prevBtn) {
      prevBtn.addEventListener('click', () => {
        activeSlide = (activeSlide - 1 + slides.length) % slides.length;
        renderCarousel();
        renderSlideDetail();
      });
    }

    if (!productMode && nextBtn) {
      nextBtn.addEventListener('click', () => {
        activeSlide = (activeSlide + 1) % slides.length;
        renderCarousel();
        renderSlideDetail();
      });
    }

    deviceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeDevice = normalizeDevice(button.dataset.guideDevice);
        activeSlide = 0;
        renderAll();
      });
    });

    gradeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeGrade = normalizeGrade(button.dataset.guideGrade);
        activeSlide = 0;
        renderAll();
      });
    });

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-rebx-grading-guide]').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
